<template>
  <div class="absolute z-20 top-0 right-0 p-4 w-full max-w-xl h-full">
    <div class="bg-base-100 overflow-hidden h-full w-full rounded-2xl">
      <slot />
    </div>
  </div>
</template>
